import { Badge } from '@/components/ui/badge'
import { formatSmartCurrency } from '@/utils/formatCurrency'

interface OrderAmountAndTagsProps {
	valueCents: number
	tags?: string[]
}

export function OrderAmountAndTags({ valueCents, tags }: OrderAmountAndTagsProps) {
	return (
		<div className="flex items-center gap-3">
			{/* Amount column - matches avatar width (36px) and centered */}
			<div className="w-9 flex justify-center">
				<div className="text-sm font-medium">
					{formatSmartCurrency(valueCents)}
				</div>
			</div>
			{/* Tags column - left-aligned with name/contact info */}
			<div className="flex-1 flex flex-wrap gap-1">
				{(tags || []).map((tag) => (
					<Badge 
						key={tag} 
						variant="secondary" 
						className="text-xs bg-muted text-foreground"
					>
						{tag}
					</Badge>
				))}
			</div>
		</div>
	)
}
